import { LogService } from '../../../../../services/log-service';

import { suggestRule } from '../../../api/automation-rules';
import { buildSystemPrompt } from './ai-rule-creator-helper';
import messages from '../messages';

export const generateAutomationRule = async (userPrompt, tags = [], automationRuleData = {}) => {
  const systemPrompt = buildSystemPrompt(tags, automationRuleData);

  const requestBody = {
    userPrompt,
    systemPrompt,
  };

  try {
    const toolResult = await suggestRule(requestBody);

    const { name, orderRuleActions, active } = toolResult;
    // Validate the response has required fields
    if (!name || !orderRuleActions || (!active && name.includes('Invalid'))) {
      return {
        success: false,
        errorMessageDescriptor: messages.invalidRequest,
      };
    }

    return {
      success: true,
      data: toolResult,
    };
  } catch (error) {
    LogService.logError(new Error('AI automation rule generation failed', { cause: error }));
    let errorMessageDescriptor = messages.unhandledError;

    if (error.response) {
      const status = error.response.status;

      if (status === 500) {
        errorMessageDescriptor = messages.invalidRequest;
      } else if (status === 400) {
        errorMessageDescriptor = messages.invalidRequest;
      } else if (status === 429) {
        errorMessageDescriptor = messages.tooManyRequests;
      } else if (status === 401 || status === 403) {
        errorMessageDescriptor = messages.authenticationIssue;
      } else {
        errorMessageDescriptor = messages.invalidRequest;
      }
    } else if (error.request) {
      errorMessageDescriptor = messages.noResponse;
    }

    return {
      success: false,
      errorMessageDescriptor,
    };
  }
};
